import { mixins, styled } from '@bob/library'

export const QuoteNumberWrapper = styled.div`
  ${mixins.typography.paragraphMedium};
  ${mixins.margin.bottom(10)};
  display: flex;
  align-items: center;
`

export const ClearQuote = styled.button`
  ${mixins.cta.tertiary('black')};
  flex: none;
  @media print {
    display: none;
  }
`
